import styled from 'styled-components';

import { StatusBannerAutoHide } from '@xing-com/banner';
import { mediaWideNavless, zIndexBanner } from '@xing-com/layout-tokens';
import { scale180 } from '@xing-com/tokens';

/**
 * This fixed positioned container should be added to work around a problem with
 * StatusBanner with fixed display, which always appears in the bottom of the page
 * regardless of styling or not the component
 */
const StatusBannerFixedContainer = styled.div`
  bottom: ${scale180}; /* Needed to position it over the bottom bar */
  left: 0;
  position: fixed;
  right: 0;
  z-index: ${zIndexBanner};

  @media ${mediaWideNavless} {
    bottom: 0;
  }
`;

const StatusBanner = styled(StatusBannerAutoHide)`
  & > div {
    justify-content: start;
  }
`;

export const Styled = {
  StatusBannerFixedContainer,
  StatusBanner,
};
